import React from 'react';

import { useIntl } from 'react-intl';

import { IconAllMenu } from 'components/icons/all-menu';

import { TileImageWrapper, TileLabel, TileWithoutCurrent } from './styles';

export const MainMenuCarouselHeader: React.FC<{ to: string }> = ({ to }) => {
  const { formatMessage } = useIntl();

  return (
    <TileWithoutCurrent to={to} $noBorder data-testid="main-menu-header-scroller-tile-all-menu">
      <TileImageWrapper data-testid="main-menu-header-scroller-tile-image">
        <IconAllMenu />
      </TileImageWrapper>
      <TileLabel as="span" to={to}>
        {formatMessage({ id: 'allMenu' })}
      </TileLabel>
    </TileWithoutCurrent>
  );
};
